import { render, staticRenderFns } from "./AdvanceRequisiteRulesReadonly.vue?vue&type=template&id=55b3f37a&"
import script from "./AdvanceRequisiteRulesReadonly.vue?vue&type=script&lang=js&"
export * from "./AdvanceRequisiteRulesReadonly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports